import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.transferStock;
const getResBranch = (state: AppState) => state.transferStock.responseBranch;
const getResponseMakeFee = (state: AppState) => state.transferStock.responseMakeFee;
const getDataCreate = (state: AppState) => state.transferStock.dataCreate;
const getResponseCreated = (state: AppState) => state.transferStock.responseCreate;
const getResponseConfirm = (state: AppState) => state.transferStock.responseConfirm;
const getResponseAuth = (state: AppState) => state.transferStock.responseAuth;

export const getTransferStockStoreSelector = createSelector(getStore, (data) => data);
export const getTransferStockResBranchSelector = createSelector(getResBranch, (account) => account);
export const getTransferStockDataCreateSelector = createSelector(getDataCreate, (data) => data);
export const getTransferStockMakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);

export const getTransferStockResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTransferStockResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTransferStockResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
